import { useState } from "react";
import { CreateSpeakerListApi } from "../../../services/apis/EventMangement/CreateEventApi";
import { toast } from "react-toastify";
import BtnLoader from "../Loader/BtnLoader";
import Swal from "sweetalert2";

const SpeakerList = ({ eventId, setTabValue }) => {
    const [multiplespeakerList, setMultipleSpeakerList] = useState([]);
    const [speakerList, setSpeakerList] = useState({
        name: "",
        photo: null,
        designation: ""
    });
    const [errors, setErrors] = useState({});
    const [normalEdit, setNormalEdit] = useState(false);
    const [confirmedSponsorId, setConfirmedSponsorId] = useState(null);
    const [btnLoading,setBtnLoading]=useState(false);
    // Handle input changes
    const handleSpeakerList = (e) => {
        const { name, value, files } = e.target;
        if (name === "photo") {
            setSpeakerList({
                ...speakerList,
                [name]: files[0],
            });
            validateField(name, files[0]);
        } else {
            setSpeakerList({
                ...speakerList,
                [name]: value,
            });
            validateField(name, value);
        }
    };

    // Validate individual fields
    const validateField = (name, value) => {
        let errorMsg = "";

        if (name === "name" && !value.trim()) {
            errorMsg = "Name is required.";
        } else if (name === "photo" && !value) {
            errorMsg = "Photo is required.";
        } else if (name === "designation" && value.trim().length < 10) {
            errorMsg = "Designation must be at least 10 characters.";
        }

        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: errorMsg,
        }));
    };

    // Validate the entire form
    const validateForm = () => {
        const newErrors = {};
        if (!speakerList.name.trim()) newErrors.name = "Name is required.";
        if (!speakerList.photo) newErrors.photo = "Photo is required.";
        if (speakerList.designation.trim().length < 10)
            newErrors.designation = "Designation must be at least 10 characters.";

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const validate = () => {
        const newErrors = {};
        if (!speakerList?.name?.trim())
          newErrors.name = "Name is required.";
    
        if (!speakerList?.photo?.trim())
          newErrors.photo = "Photo is required.";
    
        if (!speakerList?.designation?.trim())
          newErrors.designation = "Designation is required.";
    
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // Add or update the speaker
    const handleAddSpeakerList = (e) => {
        e.preventDefault();

        if (!validate()) {
            console.log("Validation errors:", errors);
            return;
        }

        const newSpeaker = {
            name: speakerList.name,
            profile_picture: speakerList.photo,
            designation: speakerList.designation
        };

        if (normalEdit) {
            setMultipleSpeakerList((prevSponsors) =>
                prevSponsors.map((sponsor, index) =>
                    index === confirmedSponsorId ? newSpeaker : sponsor
                )
            );
            setNormalEdit(false);
        } else {
            setMultipleSpeakerList([...multiplespeakerList, newSpeaker]);
        }

        setSpeakerList({
            name: "",
            photo: null,
            designation: ""
        });
        setErrors({});
    };

    const handleNormalEdit = (sponsor, id) => {
        setSpeakerList(sponsor);
        setConfirmedSponsorId(id);
        setNormalEdit(true);
    };

    const handleDeleteSpeaker = (indexToDelete) => {
        setMultipleSpeakerList((prevSponsors) =>
            prevSponsors.filter((_, index) => index !== indexToDelete)
        );
    };

    const handleSubmitData = async () => {
        const formData = new FormData();
        formData.append("speaker", JSON.stringify(multiplespeakerList));
        setBtnLoading(true)
        try {
            const response = await CreateSpeakerListApi(eventId, formData);

            if (response?.data?.success) {
                toast.success(response?.data?.message)
                setTabValue('Social-Media');
                Swal.fire({
                  icon: "success",
                  title: "Event",
                  text: response?.data?.message,
                });
            }

        } catch (error) {
            console.error("Error while submitting the form:", error);
            toast.error(error?.response?.data?.message);
        }finally{
         setBtnLoading(false)
        }
    }


    return (
        <>
            <div className="container-fluid">
                <div className="align-items-end mt-2">
                    <div className="row">
                        <div className="col-md-4">
                            <label className="form-label">
                                Name<span className="asterisk">*</span>
                            </label>
                            <input
                                className="form-control"
                                type="text"
                                name="name"
                                value={speakerList.name}
                                onChange={handleSpeakerList}
                                placeholder="Ex: Name"
                                maxLength={80}
                            />
                            {errors.name && <small className="text-danger">{errors.name}</small>}
                        </div>

                        <div className="col-md-4">
                            <label className="form-label">
                                Photo<span className="asterisk">*</span>
                            </label>
                            <input
                                className="form-control"
                                type="file"
                                accept="image/*"
                                name="photo"
                                onChange={handleSpeakerList}
                            />
                            {errors.photo && <small className="text-danger">{errors.photo}</small>}
                        </div>
                    </div>

                    <div className="col-md-4">
                        {speakerList?.photo !== null && (
                            <div className="mt-3">
                                <div className="d-flex justify-content-end">
                                    <button
                                        className="img-close-btn"
                                        type="button"
                                        onClick={() => setSpeakerList({ ...speakerList, photo: null })}
                                    >
                                        {/* Close Icon */}
                                    </button>
                                </div>
                                <div className="mt-2 d-flex justify-content-start">
                                    {speakerList?.photo instanceof File && (
                                        <img
                                            className="event-logo-img"
                                            src={URL.createObjectURL(speakerList?.photo)}
                                            alt="Uploaded"
                                            height="200px"
                                            width="200px"
                                        />
                                    )}
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="row">
                        <div className="col-md-8 mt-3">
                            <label className="form-label">
                                Designation<span className="asterisk">*</span>
                            </label>
                            <textarea
                                value={speakerList.designation}
                                name="designation"
                                rows="3"
                                onChange={handleSpeakerList}
                                className="form-control"
                                placeholder="Ex: Desination"
                                maxLength={500}

                            />
                            {errors.designation && (
                                <small className="text-danger">{errors.designation}</small>
                            )}
                        </div>
                    </div>

                    <div className="row mt-4">
                        <div className="col-4 create-event-save-btn">
                            <button
                                className=""
                                type="button"
                                onClick={handleAddSpeakerList}>
                                Add Speaker List
                            </button>
                        </div>

                        <div className="col-4 d-flex justify-content-end gap-4">
                            <div className="">
                            <div className="">
                                    <button className="btn btn-outline-primary" type="button"
                                     onClick={()=>setTabValue("Domain-Info")}
                                    >Skip</button>
                                </div>
                            </div>
                            {multiplespeakerList.length > 0 ?
                                <div className="">
                                    <button className="btn btn-primary" onClick={handleSubmitData}>{btnLoading && <BtnLoader/>} Save and Continue</button>
                                </div> :
                                <div className="">
                                    <button className="btn btn-primary" onClick={() => alert("Add at least 1 speaker in list")}>Save and Continue</button>
                                </div>
                            }


                        </div>
                    </div>
                </div>

                {multiplespeakerList.length > 0 && (
                    <div className="mt-3">
                        <ul className="p-0">
                            {multiplespeakerList.map((list, index) => (
                                <li
                                    key={index}
                                    className="d-flex justify-content-between gap-2 align-items-center mt-2 border py-2 px-4"
                                >
                                    <img
                                        src={URL.createObjectURL(list?.profile_picture)}
                                        alt={list.name}
                                        className="border"
                                        height='100px'
                                        width='100px'
                                    />
                                    <p className="text-capitalize p-0 m-0">{list.name}</p>
                                    <div className="">{list.designation}</div>
                                    <div className="d-flex gap-2 create-event-save-btn">
                                        <button
                                            className=""
                                            type="button"
                                            onClick={() => handleNormalEdit(list, index)}
                                        >
                                            Edit
                                        </button>
                                        <button
                                            className=""
                                            type="button"
                                            onClick={() => handleDeleteSpeaker(index)}
                                        >
                                            Delete
                                        </button>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>
                )}
            </div>
        </>
    );
};

export default SpeakerList;
